import React from 'react';
import { Icon } from './Icon.jsx';

export function Button({
  variant = 'primary', size = 'md', iconLeft, iconRight, loading = false,
  block = false, disabled = false, as, href, children, className = '', ...rest
}) {
  const Tag = as || (href ? 'a' : 'button');
  const cls = [
    'sp-btn', 'sp-btn--' + variant, 'sp-btn--' + size,
    block && 'sp-btn--block', loading && 'sp-btn--loading', className
  ].filter(Boolean).join(' ');
  const iconSize = size === 'lg' ? 17 : size === 'sm' ? 14 : 15;
  return (
    <Tag
      className={cls}
      href={href}
      disabled={Tag === 'button' ? disabled || loading : undefined}
      aria-disabled={Tag !== 'button' && (disabled || loading) ? 'true' : undefined}
      aria-busy={loading || undefined}
      {...rest}
    >
      {iconLeft && <span className="sp-btn__icon"><Icon name={iconLeft} size={iconSize} /></span>}
      {children}
      {iconRight && <span className="sp-btn__icon"><Icon name={iconRight} size={iconSize} /></span>}
    </Tag>
  );
}
